<template>
  <v-app light>
    <v-slide-y-transition mode="out-in">
      <router-view></router-view>
    </v-slide-y-transition>
    <v-snackbar
      :timeout="toastShow.time"
      :color = "toastShow.color"
      :top="true"
      :right="true"
      v-model="toastShow.visibility"
    >
     {{ toastShow.text }}
    </v-snackbar>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        fixed: true
      }
    },
    computed: {
      toastShow () {
        return this.$store.getters.toastr
      }
    }
  }
</script>

<style lang="stylus">
  .application.theme--light{
    background:#fff!important;
  }
  html,body{
    overflow: auto;
  }
  h1, h2{
    font-size: 112px;
  }
  h4, h3{
    font-size: 34px;
  }
  h6{
    font-size: 20px;
  }
  h5{
    font-size: 24px;
  }
  main{
    height: 100%;
  }
  main{
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  html,body,.no-bar {
      overflow: scroll;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
  }
  html::-webkit-scrollbar,body::-webkit-scrollbar,.no-bar::-webkit-scrollbar {
      display: none;
  }
  .link,.link a{
    color: #1470c8;
    cursor: pointer;
    text-decoration: none;
  }
  .link:hover,.link a:hover{
    color: #1382ec;
    text-decoration: none;
  }
  .img-responsive{
    width:100%;
    height:auto;
  }
  main{
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
  }
  main>div{
    height:100%;
  }
  .pull-right{
    float: right;
  }
  .pull-left{
    float: left;
  }
  @import './stylus/main'
  .btn-green{
    color: #fff!important;
    background-color: #009865!important;
  }
  .btn-green a{
    color: #fff!important;
    background-color: #009865!important;
  }
  .btn-red{
    background-color: rgb(234, 29, 36)!important;
  }
  .btn-red a{
    color: #fff!important;
    text-decoration: none!important;
  }
  a.voltar{
    color:transparent!important;
    text-decoration: none!important;
  }
  .captalize{
    text-transform: capitalize!important;
  }
  .sub-tab-color{
    background-color: #eaedf4;
  }
  .noselect {
  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}
.loading-modal {
  position:absolute;
  right:0;
  left:0;
  bottom: -18px
}
</style>




// WEBPACK FOOTER //
// App.vue?57e473ff